import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UiKitModule } from '@serviceplan/ui-kit';
import { AssetUIModel, ClientCoreModule, ClientEnvironment, CommonUtilityLib, ENVIRONMENT } from '@thehubz/client/core';
import { Asset, CreateAssetDto } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AssetFullScreen } from '../../../../../full-screen/asset-full-screen';
import { AssetAudioComponent } from '../asset-audio/asset-audio.component';
import { AssetHtmlBannerComponent } from '../asset-html-banner/asset-html-banner.component';
import { AssetImageComponent } from '../asset-image/asset-image.component';
import { AssetPdfComponent } from '../asset-pdf/asset-pdf.component';
import { AssetPowerPointComponent } from '../asset-power-point/asset-power-point.component';
import { AssetVideoComponent } from '../asset-video/asset-video.component';
import { AssetCommonService } from './../../../../../services/asset-common.service';

@Component({
  selector: 'thehubz-asset-view',
  templateUrl: './asset-view.component.html',
  styleUrls: ['./asset-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    UiKitModule,
    ClientCoreModule,
    AssetImageComponent,
    AssetVideoComponent,
    AssetAudioComponent,
    AssetPdfComponent,
    AssetHtmlBannerComponent,
    AssetPowerPointComponent,
  ],
})
export class AssetViewComponent implements OnChanges, OnInit {
  @Input() data!: AssetUIModel;
  @Input() previewURL?: string;

  AssetTypes = CreateAssetDto.AssetTypeEnum;
  storedAssetsIds = [];
  brandingKey!: CustomClients;
  CustomClients = CustomClients;

  Status = Asset.StatusEnum;

  constructor(
    @Inject(ENVIRONMENT) private readonly env: ClientEnvironment,
    private assetCommonService: AssetCommonService,
    private commonUtilityLib: CommonUtilityLib,
    protected assetFullScreen: AssetFullScreen,
  ) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  ngOnInit(): void {
    this.getAssetVisible();
  }

  ngOnChanges(): void {
    if (this.data && !this.commonUtilityLib.isEmptyObject(this.data)) {
      if (this.previewURL) this.data.previewUrl = this.previewURL;
    }
  }

  getAssetVisible() {
    this.storedAssetsIds = JSON.parse(sessionStorage.getItem('assetsGalleryIdsList') || '[]');
  }

  changeAsset(isNext: boolean) {
    this.assetCommonService.assetIDSubject.next(isNext);
  }
}
